export const UserProfileCss = {
  input: {
    color: "#ccc",
    border: "1px solid #1E272D",
    background: "#1E272D",
    height: "45px",
    borderRadius: "0px",
    marginBottom: "12px"
  }
};
